import cleanDeep from 'clean-deep'
import moment from 'moment'

import getAxiosInstance from '../../helpers/get_axios_instance'
import lrsAdapter from '../../helpers/lrs_adapter'
import { parseEntityId } from '../entity'

class IngresoCompleto {
  constructor (args = {}) {
    Object.keys(args).forEach(key => { this[key] = args[key] })
  }

  save () {
    const axios = getAxiosInstance()
    const ingresoData = this.getDataWithApiFormat()
    const valores = this.adaptToLrs(ingresoData)
    const promise = axios.put(`carta_de_porte_automotor_ingreso`,
      cleanDeep({ valores: { ...valores }, clave: { numero: ingresoData.numero } })
    )
    return promise.then(lrsAdapter, lrsAdapter)
  };

  attrsForCtgUpdate (dataSet = null) {
    dataSet = dataSet || this
    const attrs = [
      'estadoCtg', 'cereal', 'exportador',
      'titular', 'remitenteComercialVentaPrimaria', 'corredorComprador',
      'vendedor', 'camion', 'codigoCupo', 'cerealVariedad',
      'pesoNeto', 'transportista', 'chofer', 'ctg',
      'validacionCtg', 'cosecha', 'cpeSucursal', 'cpeSecuencia']
    return cleanDeep(attrs.reduce((obj, attr) => {
      obj[attr] = dataSet[attr]
      return obj
    }, {}))
  }

  static confirmarArriboCPE (numero, cpeSucursal, cpeSecuencia, cuentayorden) {
    const axios = getAxiosInstance()
    const titular = parseEntityId(cuentayorden)
    const promise = axios.put(`/carta_de_porte_automotor_ingreso`,
      `{"valores": {"cpe_sucursal": "${cpeSucursal}", "cpe_secuencia": "${cpeSecuencia}", "cuentayorden": "${titular}",
    "estado_ctg": "V"}, "clave": {"numero": "${numero}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
  }

  static confirmarArriboCPECompleto (numero, cpeSucursal, cpeSecuencia, cuentayorden) {
    const axios = getAxiosInstance()
    const promise = axios.put(`/carta_de_porte_automotor_ingreso`,
      `{"valores": {"cpe_sucursal": "${cpeSucursal}", "cpe_secuencia": "${cpeSecuencia}", "cuentayorden": "${cuentayorden}",
    "estado_ctg": "V"}, "clave": {"numero": "${numero}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
  }

  confirmarArribo () {
    const axios = getAxiosInstance()
    const arriboData = this.getDataWithApiFormat()

    const v = this.attrsForCtgUpdate(arriboData)
    const promise = axios.put(`/carta_de_porte_automotor_ingreso`,
      cleanDeep({
        valores: { ...v, estadoCtg: 'V' },
        clave: { numero: arriboData.numero }
      }))

    return promise.then(lrsAdapter, lrsAdapter)
  }

  getAutocompleteAttrs () {
    return [
      'exportador',
      'titularDeCupo',
      'corredorComprador',
      'mercadoATermino',
      'corredorVendedor',
      'vendedor',
      'intermediario',
      'cuentayorden',
      'transportista',
      'intermediarioFlete',
      'titular',
      'remitenteComercialProductor',
      'remitenteComercialVentaPrimaria',
      'remitenteComercialVentaSecundaria',
      'chofer'
    ]
  };

  getDataWithApiFormat () {
    const autocompleteAttrs = this.getAutocompleteAttrs()
    const result = {}
    Object.keys(this).forEach(attr => {
      result[attr] = this[attr]
      autocompleteAttrs.includes(attr) &&
        this[attr] &&
        (() => { result[attr] = parseEntityId(this[attr]) })()
    })
    return result
  };

  adaptToLrs (ingresoData = {}) {
    const {
      estadoCtg,
      validacionCtg,
      observacionesCtg,
      fechaDeVencimiento,
      cereal,
      cerealVariedad,
      exportador,
      corredorComprador,
      mercadoATermino,
      corredorVendedor,
      vendedor,
      intermediario,
      transportista,
      intermediarioFlete,
      cosecha,
      localidad,
      codigoDeEmisionElectronica,
      renspa,
      establecimientoDeOrigen,
      contrato,
      kmRecorridos,
      ctg,
      biotecnologiaCereal,
      usuarioIngreso,
      camion,
      tipoCupo,
      fechaCupo,
      codigoCupo,
      acoplado,
      chofer,
      tarifa,
      tarifaReferencia,
      turnoSinCupo,
      fechaAsignacionTurnoDeSalida,
      turnoDeSalida,
      pesoTara,
      pesoNeto,
      pesoBruto,
      pesoNetoCtgDefinitivo,
      codigoCtc,
      remitenteProductor,
      canjeador,
      titular,
      remitenteComercialProductor,
      remitenteComercialVentaPrimaria,
      remitenteComercialVentaSecundaria,
      cpeSucursal,
      cpeSecuencia
    } = ingresoData

    return {
      estadoCtg,
      validacionCtg,
      observacionesCtg,
      fechaDeVencimiento: moment(fechaDeVencimiento).format('YYYY-MM-DD'),
      cereal,
      cerealVariedad,
      exportador,
      corredorComprador,
      mercadoATermino,
      corredorVendedor,
      vendedor,
      intermediario,
      transportista,
      intermediarioFlete,
      cosecha,
      localidad,
      codigoDeEmisionElectronica,
      renspa,
      establecimientoDeOrigen: (establecimientoDeOrigen !== '') ? establecimientoDeOrigen : null,
      contrato,
      kmRecorridos,
      ctg,
      biotecnologiaCereal,
      usuarioIngreso,
      camion: camion.toUpperCase(),
      tipoCupo,
      fechaCupo,
      codigoCupo,
      acoplado: acoplado.toUpperCase(),
      chofer,
      tarifa,
      tarifaReferencia,
      turnoSinCupo,
      fechaAsignacionTurnoDeSalida,
      turnoDeSalida,
      pesoTara,
      pesoNeto,
      pesoBruto,
      pesoNetoCtgDefinitivo,
      codigoCtc,
      remitenteProductor,
      canjeador,
      cuentayorden: titular,
      remitenteComercialProductor,
      remitenteComercialVentaPrimaria,
      remitenteComercialVentaSecundaria,
      cpeSucursal,
      cpeSecuencia
    }
  }
}

export default IngresoCompleto
